import axios from '../utils/axios';

export default function getRecruiterStatusLogsCount(adminId, params) {
    return axios.get(`/admin/${adminId}/recruiter-status-logs-count`, { params });
}